import { Page, PreviewPage } from '@models/page';
import { httpPost } from './apiService';
import { TaggedSlugEntityPublicApiService } from './taggedSlugEntityPublicApiService';

export class PagePublicService extends TaggedSlugEntityPublicApiService<Page> {
    constructor() {
        super('/api/page');
    }

    public async getPagePreviewById(pagePreviewId: string, password: string): Promise<PreviewPage> {
        const result = await httpPost(
            `${this.baseUrl}/preview`,
            JSON.stringify({ previewId: pagePreviewId, password: password })
        );

        return result.json();
    }
}
